import { taskApi } from 'api';
import { ContactNoteResponse } from 'pco-product-service-internal-consumer';

export const getContactNotesByBrUidApi = async (brUid: string): Promise<ContactNoteResponse> => {
  return await taskApi.getContactNotesByBr({ brUid });
};
